import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { UIHelper } from '../../utils/UIHelper';
import { SidebarHeader } from '../SidebarHeader';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { LongButton } from '../LongButton';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { SidebarModule } from '../../constants/Enums';

interface ShareMenuProps extends React.Props<ShareMenu> {
    visible: boolean;
    layoutType: LayoutType;
}

interface ShareMenuState {
}

export class ShareMenu extends BaseComponent<ShareMenuProps, ShareMenuState> {
    public componentDidMount(): void {
        if (this.props.visible) {
            UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
        }
    }

    public componentDidUpdate(): void {
        if (this.props.visible) {
            UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
        }
    }

    public render(): JSX.Element | null {
        if (!this.props.visible) {
            return null;
        }
        return (
            <div className="sidebar-tab-container" key={this.props.layoutType.toString()}><div className="scrollbar-wcf">
                <SidebarHeader text={t('Send')}/>
                <div className="sidebar-content standard-header">
                    <div className="long-button-group">
                        {AppConfigurationStore.shareFormatAvailable('Download') ? (
                            <LongButton
                                className="with-arrow short-border dl-button with-icon"
                                onClick={() => { ViewSettingsActions.changeSidebar(SidebarModule.SHARE_DL); }}
                            >
                                {t('Download')}
                            </LongButton>
                        ) : null
                        }
                        {AppConfigurationStore.shareFormatAvailable('App') ? (
                            <LongButton
                                className="with-arrow short-border with-icon app-button"
                                onClick={() => { ViewSettingsActions.changeSidebar(SidebarModule.SHARE_APP); }}
                            >
                                {t('Open in app')}
                            </LongButton>
                        ) : null
                        }
                        {AppConfigurationStore.shareFormatAvailable('Mail') ? (
                            <LongButton
                                className="with-arrow short-border mail-button with-icon"
                                onClick={() => { ViewSettingsActions.changeSidebar(SidebarModule.SHARE_MAIL); }}
                            >
                                {t('Send via e-mail')}
                            </LongButton>
                        ) : null
                        }
                        {AppConfigurationStore.shareFormatAvailable('Formular') ? (
                            <LongButton
                                className="with-arrow short-border mail-button with-icon"
                                onClick={() => {ViewSettingsActions.changeSidebar(SidebarModule.SHARE_FORMULAR); }}
                            >
                                {t('Contact request')}
                            </LongButton>
                        ) : null
                        }
                    </div>
                </div>
            </div></div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/ShareMenu.tsx